module.exports = __webpack_public_path__ + "media/v2/components/HomePage/shared/PrizeSlider/img/new/jamal_imagem-fad71934357458f2e4af828534b24b0a.png";